import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-495e1296"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "live-player-control" }
const _hoisted_2 = { class: "control-progress" }
const _hoisted_3 = { class: "control-progress-time" }
const _hoisted_4 = { class: "control-progress-duration" }

import {withDefaults} from 'vue';
import {formatVideoTime} from 'common/util';


export default /*#__PURE__*/_defineComponent({
  props: {
    duration: { default: 0 },
    currentTime: { default: 0 },
    isPlaying: { type: Boolean, default: false }
  },
  emits: ['click-play', 'click-process', 'touch-end'],
  setup(__props: any, { emit }) {





function clickPlay() {
    emit('click-play');
}
function clickProcess() {
    emit('click-process');
}
function touchEnd() {
    emit('touch-end');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['control-btn click-extend', __props.isPlaying ? 'icon-pause' : 'icon-play']),
      onClick: clickPlay
    }, null, 2 /* CLASS */),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(formatVideoTime)(__props.currentTime)), 1 /* TEXT */),
      _createElementVNode("div", {
        class: "control-progress-bar",
        onClick: clickProcess
      }, [
        _createElementVNode("div", {
          class: "control-progress-bar__played",
          style: _normalizeStyle({width: `${(__props.currentTime / __props.duration) * 100}%`})
        }, [
          _createElementVNode("div", {
            class: "control-progress-bar__point",
            onTouchend: touchEnd
          }, null, 32 /* HYDRATE_EVENTS */)
        ], 4 /* STYLE */)
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(formatVideoTime)(__props.duration)), 1 /* TEXT */)
    ])
  ]))
}
}

})